import { FirmHome } from "./pages/Firms/Home/FirmHome";
import ErrorPage from "./pages/Result/Error";
import Missing from "./pages/Result/Missing";
import FirmLayout from "./pages/RootLayout/FirmLayout";
import HomeLayout from "./pages/RootLayout/HomeLayout";
import WorkerLayout from "./pages/RootLayout/PersonnelLayout";
import PersonnelHome from "./pages/Personnel/Home/PersonnelHome";
import PageRoutes from "./utils/routes";
import { Route, Routes as Router } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider.js";
import RequireAuth from "./components/RequireAuth.js";
import PersistLogin from "./components/PersistLogin.jsx";
import Unauthorized from "./pages/Result/Unauthorized.js";
import HomePage from "./pages/Home/Home.jsx";
import { ConfigProvider } from "antd";
import Listings from "./pages/Listings/Listings.jsx";
import LoginFirm from "./pages/auth/LoginFirm.jsx";
import LoginWorker from "./pages/auth/LoginPersonnel.jsx";
import SignUpFirm from "./pages/auth/SignUpFirm.jsx";
import SignUpWorker from "./pages/auth/SignUpPersonnel.jsx";
import { theme } from "./utils/theme.js";
import ForgotPasswordFirm from "./pages/auth/ForgotPasswordFirm.jsx";
import ForgotPasswordWorker from "./pages/auth/ForgotPasswordPersonnel.jsx";
import FirmProfile from "./pages/Firms/Profile/FirmProfile.jsx";
import FirmUsers from "./pages/Firms/FirmUsers/FirmUsers.jsx";
import AddFirmUser from "./pages/Firms/FirmUsers/AddFirmUser.jsx";
import UpdateFirmUser from "./pages/Firms/FirmUsers/UpdateFirmUser.jsx";
import locale from "antd/lib/locale/tr_TR";
import "dayjs/locale/tr";
import AdvertDetails from "./pages/Firms/Advert/AdvertDetails.jsx";
import AdvertDetailPersonnel from "./pages/Personnel/Advert/AdvertDetailPersonnel.jsx";
import DetailedProfile from "./pages/Personnel/Profile/DetailedProfile.jsx";
import { FavoritesPage } from "./pages/Personnel/Favorites/FavoritesPage.jsx";
import PersonnelLayout from "./pages/RootLayout/PersonnelLayout";
import PersonelSettings from "./pages/Personnel/Settings/PersonnelSettings.jsx";
import CreateAdvert from "./pages/Firms/CreateEditAdvert/CreateAdvert.jsx";
import AuthHomePage from "./pages/auth/AuthHomePage.jsx";
import { AppliedAdverts } from "./pages/Personnel/AppliedAdverts/AppliedAdverts.jsx";
import { AssignedAdverts } from "./pages/Personnel/AssignedAdverts/AssignedAdverts.jsx";
import { RecommendedAdverts } from "./pages/Personnel/RecommendedAdverts/RecommendedAdverts.jsx";
import DocumentManagement from "./pages/Personnel/DocumentManagement/DocumentManagement.jsx";
import DocumentUpload from "./pages/Personnel/DocumentManagement/DocumentUpload.jsx";
import DocumentUploadFirm from "./pages/Firms/DocumentManagement/DocumentUploadFirm.jsx";
import Adverts from "./pages/Firms/Advert/Adverts.jsx";
import EditAdvert from "./pages/Firms/CreateEditAdvert/EditAdvert.jsx";
import CopyAdvert from "./pages/Firms/CreateEditAdvert/CopyAdvert.jsx";
import FirmDocuments from "./pages/Firms/Profile/FirmDocuments.jsx";
import Agreements from "./pages/Agreements/Agreements.jsx";
import DataDelete from "./pages/Agreements/DataDelete.jsx";

function App() {
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: theme.primaryColor, // Applies to all components
          // borderRadius: data.borderRadius,
        },
        components: {
          // Menu: {
          //   horizontalItemSelectedBg: theme.lightPrimaryColor,
          // },
          // Button: {
          //   colorPrimary: primaryColor, // Specific to Button component
          // },
        },
      }}>
      <AuthProvider>
        <Router>
          {/* Home Page */}
          <Route element={<HomeLayout />}>
            <Route path={PageRoutes.home} element={<HomePage />} />
            <Route path={PageRoutes.authHomePage} element={<AuthHomePage />} />

            <Route path={PageRoutes.loginFirm} element={<LoginFirm />} />
            <Route path={PageRoutes.loginWorker} element={<LoginWorker />} />
            <Route path={PageRoutes.signupFirm} element={<SignUpFirm />} />
            <Route path={PageRoutes.signupWorker} element={<SignUpWorker />} />
            <Route
              path={PageRoutes.forgotPasswordFirm}
              element={<ForgotPasswordFirm />}
            />
            <Route
              path={PageRoutes.forgotPasswordWorker}
              element={<ForgotPasswordWorker />}
            />

            <Route
              path={PageRoutes.detailedProfile}
              element={<DetailedProfile />}
            />
            <Route path={PageRoutes.sözlesme} element={<Agreements />} />
            <Route path={PageRoutes.dataDelete} element={<DataDelete />} />
          </Route>

          {/* Firm Section */}
          <Route element={<PersistLogin />}>
            <Route element={<RequireAuth allowedRoles={["FIRM"]} />}>
              <Route element={<FirmLayout />}>
                {/* Firm-specific routes */}
                <Route path={PageRoutes.firmHome} element={<FirmHome />} />
                <Route
                  path={PageRoutes.createAdvert}
                  element={<CreateAdvert />}
                />
                <Route path={PageRoutes.editAdvert} element={<EditAdvert />} />
                <Route path={PageRoutes.copyAdvert} element={<CopyAdvert />} />
                <Route path={PageRoutes.firmInfo} element={<FirmProfile />} />
                <Route path={PageRoutes.firmUsers} element={<FirmUsers />} />
                <Route path={PageRoutes.adverts} element={<Adverts />} />
                <Route
                  path={`${PageRoutes.advertDetailFirm}/:advertId`}
                  element={<AdvertDetails />}
                />
                <Route
                  path={PageRoutes.addFirmUser}
                  element={<AddFirmUser />}
                />
                <Route
                  path={`${PageRoutes.updateFirmUser}/:firmUserId`}
                  element={<UpdateFirmUser />}
                />
                <Route
                  path={PageRoutes.documentUploadFirm}
                  element={<DocumentUploadFirm />}
                />
                <Route
                  path={PageRoutes.firmDocuments}
                  element={<FirmDocuments />}
                />
              </Route>
            </Route>
          </Route>

          {/* Worker Section */}
          <Route element={<PersistLogin />}>
            <Route element={<RequireAuth allowedRoles={["PERSONNEL"]} />}>
              <Route element={<HomeLayout />}>
                {/* Worker-specific routes */}
                <Route
                  path={PageRoutes.personnelHome}
                  element={<PersonnelHome />}
                />
                <Route
                  path={PageRoutes.personnelSettings}
                  element={<PersonelSettings />}
                />
                <Route
                  path={`${PageRoutes.advertDetailEmployee}/:advertId`}
                  element={<AdvertDetailPersonnel />}
                />
                <Route path={PageRoutes.listings} element={<Listings />} />
                <Route
                  path={PageRoutes.favoriteAdverts}
                  element={<FavoritesPage />}
                />
                <Route
                  path={PageRoutes.appliedAdverts}
                  element={<AppliedAdverts />}
                />
                <Route
                  path={PageRoutes.assignedAdverts}
                  element={<AssignedAdverts />}
                />
                <Route
                  path={PageRoutes.recommendedAdverts}
                  element={<RecommendedAdverts />}
                />
                <Route
                  path={PageRoutes.documentManagement}
                  element={<DocumentManagement />}
                />
                <Route
                  path={`${PageRoutes.documentUpload}`}
                  element={<DocumentUpload />}
                />
              </Route>
            </Route>
          </Route>

          {/* Error and Miscellaneous Routes */}
          <Route path={PageRoutes.error} element={<ErrorPage />} />
          <Route path={PageRoutes.missing} element={<Missing />} />
          <Route path={PageRoutes.unauthorized} element={<Unauthorized />} />
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
